import { toast } from "react-toastify";
import api from "../../../services/api";
import { ModalImagemAdministrarVitrineStyle } from "./style";
import { useParams } from "react-router-dom";
import { ModalTrocarFotoDestaque } from "../TrocarFotoDestaque";
import { useState } from "react";

export const ModalImagemAdministrarVitrine = ({
  state,
  materialVitrineImagens,
  index,
  setImagemIndex,
  buscarMaterialVitrine,
  buscarMaterialVitrineImagens,
  buscarMaterialVitrineValores,
}) => {
  const { material_id } = useParams();
  const [modalTrocarFotoDestaque, setModalTrocarFotoDestaque] = useState(false);
  const materialVitrine = materialVitrineImagens[index];

  function deletarImagemAdministrar() {
    api
      .delete(`/material-vitrine/${material_id}/anexos/${materialVitrine.id}`)
      .then((response) => {
        state(false);
        toast.success("Imagem Deletada");
        buscarMaterialVitrine();
        buscarMaterialVitrineImagens();
        buscarMaterialVitrineValores();
      })
      .catch((error) => {
        toast.error("Erro ao buscar dados");
      });
  };

  function buscarDados() {
    buscarMaterialVitrine();
    buscarMaterialVitrineImagens();
    buscarMaterialVitrineValores();
  }

  function atualizarImagemAdministrar() {
    api
      .patch(`/material-vitrine/${material_id}/anexos/${materialVitrine.id}`, {
        principal: true
      })
      .then((response) => {
        state(false);
        toast.success("Imagem atualizada como principal");
        buscarMaterialVitrine();
        buscarMaterialVitrineImagens();
        buscarMaterialVitrineValores();
      })
      .catch((error) => {
        toast.error("Erro ao atualizar imagem");
      });
  }

  return (
    <ModalImagemAdministrarVitrineStyle>
      <div className="body">
        <span onClick={() => state(false)} className="close">
          X
        </span>
        <img src={materialVitrine.url} />
        <div className="setas">
          {index > 0 ? (
            <span onClick={() => setImagemIndex(index - 1)}>&lt;</span>
          ) : (
            <span className="vazio"></span>
          )}
          <button onClick={() => atualizarImagemAdministrar()}>Destaque</button>
          {materialVitrineImagens.length - 1 > index ? (
            <span onClick={() => setImagemIndex(index + 1)}>&gt;</span>
          ) : (
            <span className="vazio"></span>
          )}
          <button className="deletar" onClick={() => {
            if (materialVitrine.principal) {
              setModalTrocarFotoDestaque(true)
            } else {
              deletarImagemAdministrar();
            }
          }}>
            Deletar foto
          </button>
        </div>
      </div>
      {modalTrocarFotoDestaque && (
        <ModalTrocarFotoDestaque
          material_id={material_id}
          buscarDados={buscarDados}
          atualizarImagemAdministrar={atualizarImagemAdministrar}
          state={setModalTrocarFotoDestaque}
          deletarImagemAdministrar={deletarImagemAdministrar}
        />
      )}
    </ModalImagemAdministrarVitrineStyle>
  );
};
